import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { LoaderService } from 'src/app/components/loader/service/loader.service';
import { QuizService } from '../services/quiz.service';

@Component({
  selector: 'app-quiz-form',
  templateUrl: './quiz-form.component.html',
  styleUrls: ['./quiz-form.component.css'],
})
export class QuizFormComponent implements OnInit {
  quizForm: FormGroup;
  isEditMode = false;
  quizId: string | number | null = null;
  pageTitle = 'Novo Quiz';

  constructor(
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private snackBar: MatSnackBar,
    private loaderService: LoaderService,
    private quizService: QuizService
  ) {
    this.quizForm = this.fb.group({
      title: ['', [Validators.required, Validators.maxLength(255)]],
      text: ['', Validators.required],
      end_date: ['', Validators.required],
      question_1: ['1 - mandamento de Deus', Validators.required],
      question_2: ['2 - promessa de Deus', Validators.required],
      question_3: ['3 - caráter de Deus', Validators.required],
      question_4: ['4 - o que Deus me revela no texto', Validators.required],
      question_5: ['5 - lição prática', Validators.required],
    });
  }

  ngOnInit(): void {
    const id = this.route.snapshot.paramMap.get('id');

    if (id && id !== 'new') {
      this.isEditMode = true;
      this.quizId = id;
      this.pageTitle = 'Editar Quiz';
      this.loadQuiz(id);
    }
  }

  loadQuiz(id: string | number): void {
    this.loaderService.showLoader();
    this.quizService
      .getQuizById(id)
      .then((res) => {
        const quiz = res.data || res;
        this.quizForm.patchValue({
          title: quiz.title,
          text: quiz.text,
          end_date: quiz.end_date ? new Date(quiz.end_date).toISOString().substring(0, 10) : '',
          question_1: quiz.question_1,
          question_2: quiz.question_2,
          question_3: quiz.question_3,
          question_4: quiz.question_4,
          question_5: quiz.question_5,
        });
        this.loaderService.closeLoader();
      })
      .catch((err) => {
        this.snackBar.open('Erro ao carregar os dados do quiz.', null, { duration: 3000 });
        this.loaderService.closeLoader();
        this.router.navigate(['/devocional']);
      });
  }

  onSubmit(): void {
    if (this.quizForm.invalid) {
      this.quizForm.markAllAsTouched();
      return;
    }

    this.loaderService.showLoader();
    const formData = this.quizForm.value;

    const request =
      this.isEditMode && this.quizId
        ? this.quizService.updateQuiz(this.quizId, formData)
        : this.quizService.createQuiz(formData);

    request
      .then((res) => {
        this.snackBar.open(`Quiz ${this.isEditMode ? 'atualizado' : 'criado'} com sucesso!`, null, { duration: 3000 });
        this.loaderService.closeLoader();
        this.router.navigate(['/devocional']);
      })
      .catch((err) => {
        this.snackBar.open(err.error?.message || 'Ocorreu um erro ao salvar o quiz.', null, { duration: 3000 });
        this.loaderService.closeLoader();
      });
  }
}
